import { render, staticRenderFns } from "./ListInvoiceInspectionsView.vue?vue&type=template&id=397bf118&scoped=true&"
import script from "./ListInvoiceInspectionsView.vue?vue&type=script&lang=js&"
export * from "./ListInvoiceInspectionsView.vue?vue&type=script&lang=js&"
import style0 from "./ListInvoiceInspectionsView.vue?vue&type=style&index=0&id=397bf118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397bf118",
  null
  
)

export default component.exports